import { c as _c } from "react/compiler-runtime";
import type { AnalyticGranularity, MetricValues } from '@/modules/finances/types';
import { useMediaQuery } from '@/modules/shared/hooks/use-media-query';
import { HeaderAnnually } from './header-annually';
import { HeaderMonthly } from './header-monthly';
import { HeaderQuarterly } from './header-quarterly';
import { SemiAnnualHeader } from './header-semi-annually';
interface TableHeaderProps {
  granularity: AnalyticGranularity;
  title: string;
  year: string;
  headerTable: MetricValues[];
  activeMetrics: string[];
}
function TableHeader(t0) {
  const $ = _c(20);
  const {
    granularity,
    title,
    year,
    headerTable,
    activeMetrics
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      to: "md"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const isMobile = useMediaQuery(t1);
  if (isMobile && granularity === "semiAnnual") {
    let t2;
    if ($[1] !== activeMetrics || $[2] !== headerTable || $[3] !== title || $[4] !== year) {
      t2 = <SemiAnnualHeader headerTable={headerTable} activeMetrics={activeMetrics} title={title} year={year} />;
      $[1] = activeMetrics;
      $[2] = headerTable;
      $[3] = title;
      $[4] = year;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    return t2;
  } else {
    if (granularity === "annual") {
      let t2;
      if ($[6] !== activeMetrics || $[7] !== headerTable || $[8] !== title || $[9] !== year) {
        t2 = <HeaderAnnually year={year} title={title} headerTable={headerTable} activeMetrics={activeMetrics} />;
        $[6] = activeMetrics;
        $[7] = headerTable;
        $[8] = title;
        $[9] = year;
        $[10] = t2;
      } else {
        t2 = $[10];
      }
      return t2;
    }
    if (granularity === "monthly") {
      let t2;
      if ($[11] !== activeMetrics || $[12] !== headerTable || $[13] !== title) {
        t2 = <HeaderMonthly headerTable={headerTable} activeMetrics={activeMetrics} title={title} />;
        $[11] = activeMetrics;
        $[12] = headerTable;
        $[13] = title;
        $[14] = t2;
      } else {
        t2 = $[14];
      }
      return t2;
    }
    let t2;
    if ($[15] !== activeMetrics || $[16] !== headerTable || $[17] !== title || $[18] !== year) {
      t2 = <HeaderQuarterly headerTable={headerTable} activeMetrics={activeMetrics} title={title} year={year} />;
      $[15] = activeMetrics;
      $[16] = headerTable;
      $[17] = title;
      $[18] = year;
      $[19] = t2;
    } else {
      t2 = $[19];
    }
    return t2;
  }
}
export { TableHeader };